export default [
    {
        name: 'links',
        sortField: 'links',
        type: 'string',
        useInFilter: true,
        isDefault: true,
        defaultSearch: true
    }

]